import ACTS from '../constants'

const defaultStatus = {
    tab: 'id'
}

export default (state = defaultStatus, action) => {
    switch(action.type) {
        case ACTS.FIND_TAB:
            return {
                ...state,
                tab: action.tab
            }
        case ACTS.FIND_ID:            
            if(action.payload.result) window.Alert.info('이메일로 아이디 정보가 발송되었습니다.');
            else window.Alert.info('일치하는 회원이 존재하지 않습니다.');
            return state

        case ACTS.FIND_PASSWD:
            if(action.payload.result) window.Alert.info('이메일로 임시 비밀번호가 발송되었습니다.');
            else window.Alert.info('일치하는 회원이 존재하지 않습니다.');
            return state

        default:        
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/find.js